import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_BASE = `${HOME_SERVICE}/community-inspection-authorities`;

export const communityInspectionAuthorities = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_BASE,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_BASE,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_BASE}/${id}`,
      method: "delete",
      data,
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  templates: {
    getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
      const options = await apiOptions({
        url: `${API_BASE}/inspection-templates`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        signal,
        params,
        filters,
        sort,
        top,
        skip,
      });
      return apiRequest(options);
    },
    create: async ({ data, toastMessageConfig }) => {
      const options = await apiOptions({
        url: `${API_BASE}/inspection-templates`,
        method: "post",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
    delete: async ({ id, data, toastMessageConfig }) => {
      const options = await apiOptions({
        url: `${API_BASE}/inspection-templates/${id}`,
        method: "delete",
        data,
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
};
